/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _default = function _default(defaultValue, theContext, name) {
  var context = (0, _react.useContext)(theContext);
  if (context.state[name] !== undefined) {
    defaultValue = context.state[name];
  }
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  return [value, function (newValue) {
    if (typeof newValue === 'function') {
      newValue = newValue(value);
    }
    context.state[name] = newValue;
    setValue(newValue);
  }];
};
exports.default = _default;